<template>
	<div class="body">
		<bg></bg>
		<div class="main">
			<div class="head">
				<h1>机老大管家 — 运营管理后台</h1>
				<p>OPERATIONAL MANAGEMENT SYSTEM</p>
			</div>
			<div class="login flex-column flex-start-center">
				<p class="title">登录中心</p>
				<c-form ref="form" class="form">
					<c-input class="item" type="text" name="user_name" placeholder="输入用户名" :clear="false" @enter="login">
						<template #prependIcon>
							<i class="item-icon tf-username tf-fw"></i>
						</template>
					</c-input>
					<c-input class="item" type="password" name="user_pwd" placeholder="请输入密码" :clear="false" @enter="login">
						<template #prependIcon>
							<i class="item-icon tf-password tf-fw"></i>
						</template>
					</c-input>
				</c-form>
				<c-button class="button" size="form" color="main" @click="login">登录</c-button>
				<p class="copyright">版权所有 ©{{new Date().getFullYear()}} 杭州小黑拍拍拍卖有限公司</p>
			</div>
		</div>
		<p class="info flex-center">
			<a :href="publicConfig ? publicConfig.platform_icp_record_url : ''" target="_blank">{{publicConfig ? publicConfig.platform_icp_record_no : '-'}}</a>
			<ins>|</ins>
			<img src="@/assets/image/beian.png"><a :href="publicConfig ? publicConfig.platform_public_security_record_url : ''" target="_blank">{{publicConfig ? publicConfig.platform_public_security_record_no : '-'}}</a>
			<ins>|</ins>
			<a :href="publicConfig ? publicConfig.platform_telecom_license_image || publicConfig.platform_icp_record_url : ''" target="_blank">{{publicConfig ? publicConfig.platform_telecom_license_name : '-'}}</a>
		</p>
	</div>
</template>

<script>
	import bg from './bg.vue'
	import {mapState} from 'vuex'
	import {cryptoJs} from '@deanwu/vue-component-library'
	
	export default {
		components: {
			bg
		},
		
		props: {
			redirect: {
				type: String,
				default: '/'
			}
		},

		computed: {
			...mapState(['publicConfig'])
		},

		methods: {
			login() {
				this.$refs.form.submit({
					url: '/sys_user/manage_login',
					breakWhenFail: true,
					rule: {
						user_name: '请输入用户名',
						user_pwd: '请输入密码'
					},
					dataFormatter: data => {
						data.saas_name = "运营公司";
						data.user_pwd = cryptoJs.MD5(data.user_pwd).toString();
						return data;
					},
					success: (data, res) => {
						this.$store.dispatch('setLoginInfo', res);
						this.navigateTo(this.redirect);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.body {
		height: 100vh;
		background: var(--color-main);

		.main {
			position: fixed;
			left: 50%;
			top: 50%;
			width: 430px;
			overflow: hidden;
			transform: translate(-50%, -50%);
			
			.head {
				text-align: center;
				color: #fff;
				
				h1 {
					font-size: 30px;
					font-weight: normal;
				}
				
				p {
					margin-top: 12px;
					font-size: 12px;
					opacity: .6;
				}
			}
			
			.login {
				position: relative;
				box-sizing: border-box;
				height: 320px;
				border-radius: 6px;
				padding-top: 48px;
				margin-top: 58px;
				background: #fff;
				
				.title {
					margin-bottom: 26px;
					font-size: 20px;
					text-align: center;
				}
				
				.form {
					gap: 0;
					width: 320px;
					padding: 0 55px;
					
					.item {
						height: 40px;
						margin-bottom: 12px;
						
						&-icon {
							margin: 0 10px 0 12px;
							font-size: 14px;
							color: #bbb;

							^[-1]:focus-within ^[-2..-1] {
								color: #000;
							}
						}

						.smscode {
							display: block;
							margin-top: 9px;
							margin-right: 8px;
							line-height: 20px;
							font-size: 12px;
							color: var(--color-main);

							&.z-dis {
								color: #999;
							}
						}
					}
				}
				
				.button {
					width: 320px;
					height: 46px !important;
					border-radius: 2px;
					margin-top: 8px;
					font-size: 18px;
				}
				
				.copyright {
					margin-top: 26px;
					font-size: 12px;
					text-align: center;
					color: #999;
				}
			}
		}
		
		.info {
			position: fixed;
			left: 0;
			right: 0;
			bottom: 0;
			height: 50px;
			font-size: 12px;
			text-align: center;
			color: #fff;

			img {
				width: 16px;
				margin-right: .5em;
			}

			a {
				opacity: .6;
				
				&:hover {
					text-decoration: underline;
					opacity: 1;
				}
			}

			ins {
				margin: 0 1em;
			}
		}
	}
</style>
